import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import ButtonPro from "src/components/atoms/primary-button/primary-button";

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
	buttonText?: string;
	buttonDisabled?: boolean;
	size?: "sm" | "md" | "lg" | "xl" | "full"; // ✅ Added size prop
}

const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	children,
	buttonText = "Ok",
	buttonDisabled = false,
	size = "md", // Default size
}) => {
	if (!isOpen) return null;

	// ✅ Handle ESC key to close modal
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				onClose();
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [onClose]);

	// ✅ Dynamic width classes
	const sizeClasses = {
		sm: "max-w-sm w-full",
		md: "max-w-md w-full",
		lg: "max-w-lg w-full",
		xl: "max-w-xl w-full",
		full: "w-full h-full flex items-center justify-center",
	}[size];

	return ReactDOM.createPortal(
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fadeIn">
			<div className={`bg-white rounded-lg shadow-lg p-6 ${sizeClasses}`}>
				{/* Modal Content */}
				<div className="flex flex-col items-center justify-center gap-4 text-center">
					{children}
					<ButtonPro
						disabled={buttonDisabled}
						onClick={onClose}
						label={buttonText}
					/>
				</div>
			</div>
		</div>,
		document.body // Append modal to body for better positioning
	);
};

export default Modal;
